module.exports = __webpack_public_path__ + "img/product-attr03.1add0b48.png";